/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService } from '../../../../core/services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicesApiService } from '../http';

@Injectable()
export class PulseHaServicesResolvers {

    constructor(
        private apiService: ApiService,
        private servicesApiService: ServicesApiService,
    ) {
    }

    public resolve(): Observable<any> {
        // eslint-disable-next-line max-len
        return this.servicesApiService.getServiceStatus({ noNotification: true }).pipe(this.apiService.handleRequest({}, 'routes').bind(this));
    }
}
